import { Modal } from "./Modal"
import { msg } from "./utils"

// Dado `res` de tipo JSON, lo dumpea como una tabla
export const ModalDump = ({ id, title, show, res, footer = null }) => {
  const body = (res) => {
    if (typeof res !== "object") return msg(JSON.stringify(res))

    const keys = Object.keys(res)
    if (keys.length === 1) return msg(res[keys[0]])

    return (
      <center className="px-2 ps-4">
        <table className="table">
          <tbody>
            {keys.map((k, ix) => (
              <tr key={ix}>
                <td>
                  <b>{k.toLocaleUpperCase()}</b>
                </td>
                <td>{res[k]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </center>
    )
  }

  return (
    <Modal
      id={id}
      show={show}
      header={<center>{title}</center>}
      body={body(res)}
      footer={footer}
      closeBtn={false}
    />
  )
}
